import { cn } from '@/lib/utils';
import { useSeesProviders } from '@/lib/useAudience';
import { Tag } from './badges';

/** The build services by the names Malible staff know them by. */
export const PROVIDER_NAME: Record<string, string> = { eas: 'Expo', bitrise: 'Bitrise' };

/**
 * Provider badge ("Expo" neutral, "Bitrise" purple) for platform operators only: clients never see the providers
 * behind Hangar (SPEC decision 23), so it renders nothing for them, wherever it is placed.
 */
export function ProviderBadge({ kind, className }: { kind: string; className?: string }) {
  if (!useSeesProviders()) return null;
  return <Tag className={cn(kind === 'bitrise' && 'text-bitrise', className)}>{PROVIDER_NAME[kind] ?? kind}</Tag>;
}
